// ロコモかADL用定数
export enum TYPE {
  None = 0,
  Locomo,
  ADL
}

// サーバ側のなのでキャメルケースは変えられない.
export interface Training {
  count: number;
  average_angle: number;
  average_duration: number;
}

export interface TrainingMenu {
  id: number;
  name: string;
}

export interface TypeVariables {
  // 比較用数.
  comp: number;
  // key用prefix.
  prefix: string;
}

// 各ステート.
// 通常のロコモ or ADL 詳細.
export const DETAIL_STATE: number = 0;
// 長期変化.
export const LONG_TERM_STATE: number = 1;
// 比較.
export const COMPARE_STATE: number = 2;
// ロコモの詳細の1ヶ月の変化での表の項目.
export const SECTION_LOCOMO_NAMES: string[] = ['腕上げ下ろし', '腕左右', 'ひざのばし', 'ももあげ', '股開閉', 'よこあげ', 'おしり', '上部腹筋', 'ローイング'];
// ADLの詳細の1ヶ月の変化での表の項目(使わない項目も含まれている).
export const SECTION_ADL_NAMES: string[] = ['お風呂またぎ', 'お風呂洗髪', 'トイレ立ち上がり', 'トイレ着脱衣',
  '更衣着脱衣(上半身)', '更衣着脱衣(靴下)', '移動 歩行'];
// ADLでスキップさせたいインデックス'更衣着脱衣(上半身)', '更衣着脱衣(靴下)'.
export const SKIP_ADL_IDX: number[] = [4, 5];

// ロコモトレーニング数.
export const MAX_LOCOMO_CNT: number = 9;
// ロコモの最小値番号.
export const LOCOMO_MIN_NO: number = 1;
// ロコモの最大値番号.
export const LOCOMO_MAX_NO: number = MAX_LOCOMO_CNT;

// ADLトレーニング数.
// ※ADLは項目としては5だが、欠番が2つあるため5+2の7
export const MAX_ADL_CNT: number = 7;
// ADLの最小値番号.
export const ADL_MIN_NO: number = 101;
// ADLの最大値番号.
export const ADL_MAX_NO: number = 100 + MAX_ADL_CNT;

// モフトレ通信(プレス)用定数.
// ロコモ予防トレーニングの文字(ひらがな含む).
export const SECTION_PRESS_LOCOMO_NAMES: string[] = [
  'うで上げ下ろし', 'うで左右', 'ひざのばし', 'ももあげ', 'また開く閉じる', 'あし横あげ', 'おしり', '上部腹筋', 'ローイング'
];

// 日常生活動作トレーニング(ADL) ※スキップする項目も含む.
export const SECTION_PRESS_ADL_NAMES: string[] = ['お風呂またぎ', 'お風呂洗髪', 'トイレ立ち上がり', 'トイレ着脱衣', '', '', '移動歩行'];

// カレンダーの日付の数字1開始、ダミー0+最大31日の1〜31日の計32要素を示す1ヶ月分の数字.
export const MONTHLY_DAYS_COUNT: number = 32;

// TODO: 「利用者設定の作成」でも作ったのであとで消す.
export const CARE_LEVELS: string[] = [
  '要支援1',
  '要支援2',
  '要介護1',
  '要介護2',
  '要介護3',
  '要介護4',
  '要介護5',
];



// WEBPACK FOOTER //
// ./src/constants/Training.tsx